/* Exotic Blvd :: mobile quick add on collection cards (coll lane, 2026-10-22).
   Markup: snippets/eb-coll-quick-add.liquid. Styles: assets/eb-coll-quick-add.css.

   Cart wiring. Turbo 11 (assets/app.js.liquid) dispatches no DOM cart event: its ajax
   add to cart (.ajax-submit handler) and its mini cart quantity change both call a private
   refreshCart(cart), which (1) writes cart.item_count into every .cart_count and (2) fetches
   the header section (?section_id=<id of the section holding [data-cart-form="mini-cart"]>)
   and swaps .js-cart_items, .js-cart_discounts, .js-cart_subtotal and .js-cart_savings.
   refreshCart is not reachable from outside app.js, so refreshTheme() below repeats those
   exact steps, then calls window.ebAnnounce.refresh() and window.ebShipMeter.refresh() when
   present (sitewide lane hooks), then dispatches document "cart:updated" (detail: { cart, source }), the event
   snippets/eb-free-shipping-bar.liquid already listens to. That meter also watches
   .cart_count and .js-cart_subtotal with a MutationObserver, so it updates either way. */
(function () {
  'use strict';
  if (window.ebCollQuickAdd) { return; }

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cartUrl = (window.PXUTheme && window.PXUTheme.routes && window.PXUTheme.routes.cart_url) || (root + 'cart');
  var JSON_HEADERS = { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };

  function url(path) { return root + path; }

  function post(path, body) {
    return fetch(url(path), {
      method: 'POST',
      headers: JSON_HEADERS,
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) {
          var e = new Error(j.description || j.message || 'Could not update the cart.');
          e.status = r.status;
          throw e;
        }
        return j;
      });
    });
  }

  function getCart() {
    return fetch(url('cart.js'), { credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  /* ---------- theme refresh (mirrors Turbo 11 refreshCart) ---------- */
  var sectionReq = null;
  var sectionReqId = 0;
  function refreshTheme(cart) {
    var counts = document.querySelectorAll('.cart_count');
    for (var i = 0; i < counts.length; i++) { counts[i].textContent = cart.item_count; }

    var forms = document.querySelectorAll('[data-cart-form]');
    var empties = document.querySelectorAll('.js-empty-cart__message');
    for (var f = 0; f < forms.length; f++) { forms[f].classList.toggle('hidden', cart.item_count === 0); }
    for (var m = 0; m < empties.length; m++) { empties[m].classList.toggle('hidden', cart.item_count !== 0); }

    var done = function () {
      /* Sitewide lane hooks (2026-10-22): announcement bar and free shipping meter. */
      try { if (window.ebAnnounce && typeof window.ebAnnounce.refresh === 'function') { window.ebAnnounce.refresh(); } } catch (e1) {}
      try { if (window.ebShipMeter && typeof window.ebShipMeter.refresh === 'function') { window.ebShipMeter.refresh(); } } catch (e2) {}
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart, source: 'eb-coll-quick-add' } }));
    };

    var mini = document.querySelector('[data-cart-form="mini-cart"]');
    var section = mini && mini.closest('.shopify-section');
    if (!section || !section.id) { done(); return Promise.resolve(); }

    var sectionId = section.id.replace('shopify-section-', '');
    if (sectionReq && sectionReq.abort) { sectionReq.abort(); }
    sectionReq = window.AbortController ? new AbortController() : null;
    sectionReqId += 1;
    var myId = sectionReqId;

    return fetch(url('?section_id=' + encodeURIComponent(sectionId)), {
      credentials: 'same-origin',
      signal: sectionReq ? sectionReq.signal : undefined
    }).then(function (r) {
      if (!r.ok) { throw new Error('Section request returned ' + r.status); }
      return r.text();
    }).then(function (html) {
      if (myId !== sectionReqId) { return; }
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var minis = document.querySelectorAll('[data-cart-form="mini-cart"]');
      ['.js-cart_items', '.js-cart_discounts', '.js-cart_subtotal', '.js-cart_savings'].forEach(function (sel) {
        var src = doc.querySelector(sel);
        if (!src) { return; }
        for (var k = 0; k < minis.length; k++) {
          var targets = minis[k].querySelectorAll(sel);
          for (var t = 0; t < targets.length; t++) { targets[t].innerHTML = src.innerHTML; }
        }
      });
      if (window.PXUTheme && window.PXUTheme.currency && window.PXUTheme.currency.show_multiple_currencies && window.currencyConverter) {
        window.currencyConverter.convertCurrencies();
      }
      done();
    }).catch(function (err) {
      if (err && err.name === 'AbortError') { return; }
      done();
    });
  }

  /* ---------- live regions ---------- */
  var toast = null;
  var toastTimer = null;
  var srLive = null;
  function ensureRegions() {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'eb-qa-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    if (!srLive) {
      srLive = document.createElement('div');
      srLive.className = 'eb-qa-sr';
      srLive.setAttribute('aria-live', 'polite');
      document.body.appendChild(srLive);
    }
  }
  function showToast(text, isError) {
    ensureRegions();
    window.clearTimeout(toastTimer);
    toast.classList.toggle('eb-qa-toast--error', !!isError);
    toast.innerHTML = '';
    var span = document.createElement('span');
    span.textContent = text;
    toast.appendChild(span);
    if (!isError) {
      var a = document.createElement('a');
      a.href = cartUrl;
      a.textContent = 'View cart';
      toast.appendChild(a);
    }
    toast.classList.add('is-on');
    toastTimer = window.setTimeout(function () {
      toast.classList.remove('is-on');
      window.setTimeout(function () { if (!toast.classList.contains('is-on')) { toast.innerHTML = ''; } }, 250);
    }, isError ? 5000 : 3500);
  }
  function announce(text) {
    ensureRegions();
    srLive.textContent = '';
    window.setTimeout(function () { srLive.textContent = text; }, 50);
  }

  /* ---------- single variant: "+" and stepper ---------- */
  function linesFor(cart, vid) {
    var out = [];
    for (var i = 0; i < cart.items.length; i++) {
      if (String(cart.items[i].variant_id) === String(vid)) { out.push(cart.items[i]); }
    }
    return out;
  }

  function paint(box) {
    var qty = box._ebQty;
    var add = box.querySelector('[data-eb-qa-add]');
    var step = box.querySelector('[data-eb-qa-stepper]');
    var count = box.querySelector('[data-eb-qa-count]');
    var showStep = (box._ebTarget > 0);
    if (count) { count.textContent = box._ebTarget; }
    if (add) { add.hidden = showStep; }
    if (step) { step.hidden = !showStep; }
    box.setAttribute('data-qty', qty);
  }

  function initBox(box) {
    if (box._ebInit) { return; }
    box._ebInit = true;
    box._ebQty = parseInt(box.getAttribute('data-qty'), 10) || 0;
    box._ebTarget = box._ebQty;
    box._ebKey = box.getAttribute('data-key') || '';
    box._ebLines = null;
  }

  function applyCartToBox(box, cart) {
    var lines = linesFor(cart, box.getAttribute('data-vid'));
    var total = 0;
    for (var i = 0; i < lines.length; i++) { total += lines[i].quantity; }
    box._ebQty = total;
    box._ebLines = lines;
    box._ebKey = lines.length ? lines[0].key : '';
  }

  function sync(box) {
    if (box._ebBusy) { return; }
    var target = box._ebTarget;
    var current = box._ebQty;
    if (target === current) { paint(box); return; }
    box._ebBusy = true;
    box.classList.add('is-busy');
    var vid = box.getAttribute('data-vid');
    var title = box.getAttribute('data-title') || 'Item';
    var req;

    if (current === 0 || !box._ebKey) {
      req = post('cart/add.js', { items: [{ id: Number(vid), quantity: target - current }] }).then(getCart);
    } else {
      var keyLine = box._ebLines && box._ebLines.length ? box._ebLines[0] : null;
      var others = keyLine ? current - keyLine.quantity : 0;
      var lineQty = Math.max(0, target - others);
      req = post('cart/change.js', { id: box._ebKey, quantity: lineQty });
    }

    req.then(function (cart) {
      applyCartToBox(box, cart);
      if (box._ebQty < box._ebTarget && box._ebTarget === target) {
        box._ebTarget = box._ebQty;
        showToast('Only ' + box._ebQty + ' of ' + title + ' available.', true);
      }
      if (current === 0 && box._ebQty > 0) {
        announce(title + ' added to cart. ' + box._ebQty + ' in cart.');
      } else {
        announce(box._ebQty + ' ' + title + ' in cart.');
      }
      return refreshTheme(cart);
    }).catch(function (err) {
      box._ebTarget = box._ebQty;
      showToast(err && err.message ? err.message : 'Could not update the cart.', true);
      return getCart().then(function (cart) { applyCartToBox(box, cart); box._ebTarget = box._ebQty; }).catch(function () {});
    }).then(function () {
      box._ebBusy = false;
      box.classList.remove('is-busy');
      paint(box);
      if (box._ebTarget !== box._ebQty) { sync(box); }
    });
  }

  function onSingle(box, delta) {
    initBox(box);
    var next = Math.max(0, box._ebTarget + delta);
    if (next === box._ebTarget) { return; }
    var wasZero = box._ebTarget === 0;
    box._ebTarget = next;
    paint(box);
    if (wasZero && next > 0) {
      var dec = box.querySelector('[data-eb-qa-inc]');
      if (dec) { dec.focus(); }
    } else if (next === 0) {
      var add = box.querySelector('[data-eb-qa-add]');
      if (add) { add.focus(); }
    }
    sync(box);
  }

  function repaintAll(cart) {
    var boxes = document.querySelectorAll('[data-eb-qa="single"]');
    for (var i = 0; i < boxes.length; i++) {
      var b = boxes[i];
      initBox(b);
      if (b._ebBusy) { continue; }
      applyCartToBox(b, cart);
      b._ebTarget = b._ebQty;
      paint(b);
    }
  }

  /* ---------- multi variant: bottom sheet ---------- */
  var sheet = null;
  var sheetOpener = null;
  var sheetPushed = false;
  var sheetBusy = false;

  function buildSheet() {
    sheet = document.createElement('div');
    sheet.className = 'eb-qa-sheet';
    sheet.hidden = true;
    sheet.innerHTML =
      '<div class="eb-qa-sheet__backdrop" data-eb-qa-close></div>' +
      '<div class="eb-qa-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="eb-qa-sheet-title" tabindex="-1">' +
        '<div class="eb-qa-sheet__head">' +
          '<h2 class="eb-qa-sheet__title" id="eb-qa-sheet-title"></h2>' +
          '<button type="button" class="eb-qa-sheet__x" data-eb-qa-close aria-label="Close">' +
            '<svg aria-hidden="true" focusable="false" width="18" height="18" viewBox="0 0 18 18"><path d="M3 3l12 12M15 3L3 15" stroke="currentColor" stroke-width="2.2" stroke-linecap="square" fill="none"/></svg>' +
          '</button>' +
        '</div>' +
        '<p class="eb-qa-sheet__prompt" id="eb-qa-sheet-prompt"></p>' +
        '<p class="eb-qa-sheet__err" role="alert"></p>' +
        '<ul class="eb-qa-sheet__list" aria-labelledby="eb-qa-sheet-prompt"></ul>' +
        '<a class="eb-qa-sheet__pdp" href="#">View full details</a>' +
      '</div>';
    document.body.appendChild(sheet);

    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-eb-qa-close]')) { e.preventDefault(); closeSheet(false); return; }
      var opt = e.target.closest('.eb-qa-opt');
      if (opt && !opt.disabled) { e.preventDefault(); chooseVariant(opt); }
    });
    sheet.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); closeSheet(false); return; }
      if (e.key !== 'Tab') { return; }
      var panel = sheet.querySelector('.eb-qa-sheet__panel');
      var nodes = panel.querySelectorAll('button:not([disabled]), a[href]');
      if (!nodes.length) { return; }
      var first = nodes[0];
      var last = nodes[nodes.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    });
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) { n.className = cls; }
    if (text != null) { n.textContent = text; }
    return n;
  }

  function openSheet(box, opener) {
    var raw = box.querySelector('[data-eb-qa-json]');
    if (!raw) { return; }
    var data;
    try { data = JSON.parse(raw.textContent); } catch (err) { return; }
    if (!sheet) { buildSheet(); }
    ensureRegions();

    sheet.querySelector('.eb-qa-sheet__title').textContent = data.title;
    sheet.querySelector('.eb-qa-sheet__prompt').textContent = data.prompt || 'Select an option';
    sheet.querySelector('.eb-qa-sheet__err').textContent = '';
    var pdp = sheet.querySelector('.eb-qa-sheet__pdp');
    pdp.href = data.url;
    pdp.setAttribute('aria-label', 'View full details for ' + data.title);
    var list = sheet.querySelector('.eb-qa-sheet__list');
    list.innerHTML = '';

    (data.variants || []).forEach(function (v) {
      var li = document.createElement('li');
      var b = el('button', 'eb-qa-opt');
      b.type = 'button';
      b.setAttribute('data-vid', v.id);
      b.setAttribute('data-name', v.name);
      b.setAttribute('data-title', data.title);
      b.appendChild(el('span', 'eb-qa-opt__name', v.name));
      b.appendChild(el('span', 'eb-qa-opt__price', v.price));
      var meta = el('span', 'eb-qa-opt__meta');
      if (!v.available) {
        b.disabled = true;
        meta.textContent = v.unit ? v.unit + '. Sold out' : 'Sold out';
      } else {
        if (v.unit) { meta.appendChild(document.createTextNode(v.unit)); }
        if (v.free) {
          if (v.unit) { meta.appendChild(document.createTextNode('. ')); }
          meta.appendChild(el('span', 'eb-qa-opt__free', 'Ships free'));
        }
      }
      if (meta.childNodes.length) { b.appendChild(meta); }
      li.appendChild(b);
      list.appendChild(li);
    });

    sheetOpener = opener;
    sheet.hidden = false;
    sheet.classList.add('is-entering');
    document.body.classList.add('eb-qa-lock');
    // force layout so the slide in runs
    void sheet.offsetHeight;
    sheet.classList.remove('is-entering');

    try { history.pushState({ ebQaSheet: true }, ''); sheetPushed = true; } catch (err) { sheetPushed = false; }

    var firstOpt = list.querySelector('.eb-qa-opt:not([disabled])') || sheet.querySelector('.eb-qa-sheet__x');
    window.setTimeout(function () { if (firstOpt) { firstOpt.focus(); } }, 30);
  }

  function closeSheet(fromPop) {
    if (!sheet || sheet.hidden) { return; }
    sheet.hidden = true;
    document.body.classList.remove('eb-qa-lock');
    if (!fromPop && sheetPushed) {
      sheetPushed = false;
      try { history.back(); } catch (err) {}
    }
    sheetPushed = fromPop ? false : sheetPushed;
    if (sheetOpener && document.contains(sheetOpener)) { sheetOpener.focus(); }
    sheetOpener = null;
  }

  function chooseVariant(opt) {
    if (sheetBusy) { return; }
    sheetBusy = true;
    var buttons = sheet.querySelectorAll('.eb-qa-opt');
    for (var i = 0; i < buttons.length; i++) { buttons[i].setAttribute('aria-disabled', 'true'); }
    opt.classList.add('is-busy');
    var err = sheet.querySelector('.eb-qa-sheet__err');
    err.textContent = '';
    var name = opt.getAttribute('data-name');
    var title = opt.getAttribute('data-title');

    post('cart/add.js', { items: [{ id: Number(opt.getAttribute('data-vid')), quantity: 1 }] })
      .then(getCart)
      .then(function (cart) {
        closeSheet(false);
        showToast('Added ' + title + ', ' + name + '.');
        repaintAll(cart);
        return refreshTheme(cart);
      })
      .catch(function (e) {
        err.textContent = e && e.message ? e.message : 'Could not add this to the cart.';
      })
      .then(function () {
        sheetBusy = false;
        opt.classList.remove('is-busy');
        for (var j = 0; j < buttons.length; j++) { buttons[j].removeAttribute('aria-disabled'); }
      });
  }

  window.addEventListener('popstate', function () {
    if (sheet && !sheet.hidden) { closeSheet(true); }
  });

  /* ---------- delegation (works for cards added by infinite scroll) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }
    var btn = t.closest('[data-eb-qa-add], [data-eb-qa-inc], [data-eb-qa-dec], [data-eb-qa-open]');
    if (!btn) { return; }
    var box = btn.closest('[data-eb-qa]');
    if (!box) { return; }
    e.preventDefault();
    e.stopPropagation();
    if (btn.hasAttribute('data-eb-qa-open')) { openSheet(box, btn); return; }
    if (btn.hasAttribute('data-eb-qa-dec')) { onSingle(box, -1); return; }
    onSingle(box, 1);
  }, true);

  /* Back/forward cache: cart may have changed on another page. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { getCart().then(repaintAll).catch(function () {}); }
  });

  /* Keep cards in step when Turbo's own mini cart changes quantities. */
  document.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.source === 'eb-coll-quick-add') { return; }
    if (e.detail && e.detail.cart) { repaintAll(e.detail.cart); } else { getCart().then(repaintAll).catch(function () {}); }
  });

  /* Turbo's own mini cart edits fire no event; they rewrite .cart_count, so watch it. */
  var ownWrite = false;
  var watchTimer = null;
  function watchCounts() {
    if (!window.MutationObserver) { return; }
    var nodes = document.querySelectorAll('.cart_count');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i]._ebQaWatched) { continue; }
      nodes[i]._ebQaWatched = true;
      new MutationObserver(function () {
        if (ownWrite) { return; }
        window.clearTimeout(watchTimer);
        watchTimer = window.setTimeout(function () { getCart().then(repaintAll).catch(function () {}); }, 300);
      }).observe(nodes[i], { childList: true, characterData: true, subtree: true });
    }
  }
  var baseRefresh = refreshTheme;
  refreshTheme = function (cart) {
    ownWrite = true;
    window.setTimeout(function () { ownWrite = false; }, 0);
    return baseRefresh(cart);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchCounts);
  } else {
    watchCounts();
  }

  /* ---------- per variant split cards (polishfix lane, 2026-10-22) ----------
     The Gravity "Show variants" script (layout/theme.liquid) clones each product card once per
     variant and points its links at ?variant=<id>. The server card describes the product, so on a
     clone the Sale sticker, the struck price and the "+" can belong to another variant. This pass
     reads the per variant JSON from snippets/product-thumbnail.liquid and makes each split card
     follow its own variant: Sale sticker and struck price only when THAT variant's compare-at price
     is above its price, and no "+" when that variant is sold out or is not the variant the "+" adds.
     Cards without a ?variant= link (one card per product) are left as the server rendered them. */
  function cardVariantId(card) {
    var links = card.querySelectorAll('a[href*="variant="]');
    for (var i = 0; i < links.length; i++) {
      var m = /[?&]variant=(\d+)/.exec(links[i].getAttribute('href') || '');
      if (m) { return m[1]; }
    }
    return null;
  }

  function syncCard(card, dataEl) {
    var vid = cardVariantId(card);
    if (!vid) { return; }
    var data;
    try { data = JSON.parse(dataEl.getAttribute('data-eb-card-variants') || dataEl.textContent); } catch (err) { return; }
    var v = null;
    for (var i = 0; i < (data.variants || []).length; i++) {
      if (String(data.variants[i].id) === vid) { v = data.variants[i]; break; }
    }
    if (!v) { return; }
    var onSale = Number(v.compare) > Number(v.price);

    /* struck price */
    var price = card.querySelector('.product-details .price');
    if (price) {
      if (price.classList.contains('sale') !== onSale) { price.classList.toggle('sale', onSale); }
      var was = price.querySelector('.was_price');
      if (onSale) {
        if (!was) {
          was = document.createElement('span');
          was.className = 'was_price';
          var cur = price.querySelector('.current_price');
          if (cur && cur.nextSibling) { price.insertBefore(was, cur.nextSibling); } else { price.appendChild(was); }
        }
        var money = was.querySelector('.money');
        if (!money || money.textContent.trim() !== v.compare_money) {
          was.innerHTML = '';
          money = document.createElement('span');
          money.className = 'money';
          money.textContent = v.compare_money;
          was.appendChild(money);
        }
      } else if (was && was.innerHTML !== '') {
        was.innerHTML = '';
      }
    }

    /* Sale sticker */
    var badges = card.querySelector('.price-ui-badges');
    if (badges) {
      var stickers = badges.querySelectorAll('.price-ui-badge__sticker--sale');
      if (onSale && !stickers.length) {
        var b = document.createElement('div');
        b.className = 'price-ui-badge';
        b.setAttribute('data-price-ui-badge', '');
        b.setAttribute('data-display-percent', 'false');
        var st = document.createElement('div');
        st.className = 'price-ui-badge__sticker price-ui-badge__sticker--sale';
        var tx = document.createElement('span');
        tx.className = 'price-ui-badge__sticker-text';
        tx.textContent = data.sale || 'Sale';
        st.appendChild(tx);
        b.appendChild(st);
        badges.insertBefore(b, badges.firstChild);
      } else if (!onSale) {
        for (var s = 0; s < stickers.length; s++) {
          var wrap = stickers[s].closest('.price-ui-badge') || stickers[s];
          if (wrap.parentNode) { wrap.parentNode.removeChild(wrap); }
        }
      }
    }

    /* "+" quick add */
    var box = card.querySelector('[data-eb-qa]');
    if (box) {
      var off = !v.available ||
        (box.getAttribute('data-eb-qa') === 'single' && String(box.getAttribute('data-vid')) !== vid);
      if (off && !box.hasAttribute('data-eb-qa-off')) {
        box.setAttribute('data-eb-qa-off', '');
        box.setAttribute('aria-hidden', 'true');
        box.style.setProperty('display', 'none', 'important');
      } else if (!off && box.hasAttribute('data-eb-qa-off')) {
        box.removeAttribute('data-eb-qa-off');
        box.removeAttribute('aria-hidden');
        box.style.removeProperty('display');
      }
    }
  }

  function syncCards() {
    var els = document.querySelectorAll('[data-eb-card-variants]');
    for (var i = 0; i < els.length; i++) {
      var card = els[i].closest('.thumbnail') || els[i].closest('.gsProductAlias');
      if (card) { syncCard(card, els[i]); }
    }
  }

  var syncTimer = null;
  function queueSync() {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncCards, 120);
  }
  function startCardSync() {
    syncCards();
    if (window.MutationObserver && document.body) {
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          if (records[i].addedNodes && records[i].addedNodes.length) { queueSync(); return; }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
    window.addEventListener('load', queueSync);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startCardSync);
  } else {
    startCardSync();
  }

  window.ebCollQuickAdd = { refreshTheme: refreshTheme, openSheet: openSheet, closeSheet: closeSheet, syncCards: syncCards };
})();
